var _path, _path2, _path3, _path4, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgNeonDark = function SvgNeonDark(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 58 57"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#12FFF7",
    fillRule: "evenodd",
    d: "M0 9.828C0 4.4 4.477 0 10 0h37.999c5.523 0 10 4.4 10 9.828v31.761c0 5.616-7.23 8.052-10.737 3.62l-10.963-13.86v16.806c0 4.885-4.03 8.845-9 8.845H10C4.478 57 0 52.6 0 47.172zm10-1.966c-1.105 0-2 .88-2 1.966v37.344c0 1.086.895 1.966 2 1.966h17.6c.552 0 .7-.44.7-.983V25.618c0-5.615 7.23-8.052 10.736-3.62L50 35.859V9.828c0-1.086.104-1.966-1-1.966z",
    clipRule: "evenodd"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#neon-dark_svg__a)",
    fillRule: "evenodd",
    d: "M0 9.828C0 4.4 4.477 0 10 0h37.999c5.523 0 10 4.4 10 9.828v31.761c0 5.616-7.23 8.052-10.737 3.62l-10.963-13.86v16.806c0 4.885-4.03 8.845-9 8.845H10C4.478 57 0 52.6 0 47.172zm10-1.966c-1.105 0-2 .88-2 1.966v37.344c0 1.086.895 1.966 2 1.966h17.6c.552 0 .7-.44.7-.983V25.618c0-5.615 7.23-8.052 10.736-3.62L50 35.859V9.828c0-1.086.104-1.966-1-1.966z",
    clipRule: "evenodd"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#neon-dark_svg__b)",
    fillRule: "evenodd",
    d: "M0 9.828C0 4.4 4.477 0 10 0h37.999c5.523 0 10 4.4 10 9.828v31.761c0 5.616-7.23 8.052-10.737 3.62l-10.963-13.86v16.806c0 4.885-4.03 8.845-9 8.845H10C4.478 57 0 52.6 0 47.172zm10-1.966c-1.105 0-2 .88-2 1.966v37.344c0 1.086.895 1.966 2 1.966h17.6c.552 0 .7-.44.7-.983V25.618c0-5.615 7.23-8.052 10.736-3.62L50 35.859V9.828c0-1.086.104-1.966-1-1.966z",
    clipRule: "evenodd"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fill: "#B9FFB3",
    d: "M48 0c5.523 0 10 4.4 10 9.828v31.761c0 5.616-7.23 8.052-10.737 3.62l-10.962-13.86v16.806c0 4.885-4.03 8.845-9 8.845.552 0 1-.44 1-.983v-30.4c0-5.614 7.23-8.051 10.737-3.618L50 35.859V1.965C50 .88 49.105 0 48 0"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "neon-dark_svg__a",
    x1: 57.999,
    x2: 7.997,
    y1: 57,
    y2: -0.861,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#B9FFB3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#B9FFB3",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "neon-dark_svg__b",
    x1: 57.999,
    x2: 23.709,
    y1: 57,
    y2: 43.429,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#1A1A1A",
    stopOpacity: 0.9
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#1A1A1A",
    stopOpacity: 0
  })))));
};
export default SvgNeonDark;